export const keyFeaturesPart1 = [
  {
    id: 'aaa-gameplay',
    item: (
      <span className="font-normal">
        <span className="font-semibold">AAA Gameplay:&nbsp;</span>
        High-quality Unreal Engine 5.4.3 graphics delivering a seamless shooter experience.
      </span>
    ),
  },
  {
    id: 'deflationary-tokenomics',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Deflationary Tokenomics:&nbsp;</span>
        Integrated buybacks and burns fueled by in-game revenue to create a sustainable economy.
      </span>
    ),
  },
  {
    id: 'sei-integration',
    item: (
      <span className="font-normal">
        <span className="font-semibold">SEI Blockchain Integration:&nbsp;</span>
        High-speed and efficient transactions tailored for gaming.
      </span>
    ),
  },
  {
    id: 'tap-to-earn',
    item: (
      <span className="font-normal">
        <span className="font-semibold">“Tap-to-Earn” Mechanic:&nbsp;</span>
        Incentivizes players to engage in the ecosystem while earning rewards.
      </span>
    ),
  },
  {
    id: 'telegram-miniapp',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Telegram MiniApp:&nbsp;</span>
        Enables asset trading and game access directly from Telegram.
      </span>
    ),
  },
];

export const keyFeaturesPart2 = [
  {
    id: 'community-reach',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Community Reach:&nbsp;</span>
        +130k Twitter followers, +30k Telegram members, and +23k Discord members.
      </span>
    ),
  },
  {
    id: 'nft-success',
    item: (
      <span className="font-normal">
        <span className="font-semibold">NFT Success:&nbsp;</span>
        Sold out 5,000 NFTs on TON.
      </span>
    ),
  },
  {
    id: 'partnerships',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Partnerships:&nbsp;</span>
        Collaborations with top gaming platforms like HyperPlay and Elixir Games.
      </span>
    ),
  },
  {
    id: 'blockchain-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Blockchain Traction:&nbsp;</span>
        Positioned as SEI blockchain’s flagship game, leveraging strategic grants and funding.
      </span>
    ),
  },
  {
    id: 'beta-launch',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Beta Launch:&nbsp;</span>
        Achieved significant user adoption and engagement during closed beta testing.
      </span>
    ),
  },
];

export const businessModel = [
  {
    id: 'in-game-purchases',
    item: (
      <span className="font-normal">
        <span className="font-semibold">In-Game Purchases:&nbsp;</span>
        Revenue generated from microtransactions, including loot boxes, skins, upgrades, and
        consumables.
      </span>
    ),
  },
  {
    id: 'marketplace-fees',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Marketplace Fees:&nbsp;</span>A small percentage (1–3%) is
        charged on transactions in the secondary marketplace.
      </span>
    ),
  },
  {
    id: 'loot-box-mechanics',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Loot Box Mechanics:&nbsp;</span>
        Players purchase loot boxes for a chance to unlock valuable in-game assets, with 100% of
        proceeds going to the treasury.
      </span>
    ),
  },
  {
    id: 'token-buyback-burn',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Token Buyback & Burn:&nbsp;</span>A portion of all revenue
        is allocated for $GPTW buybacks and burning, creating a powerful deflationary mechanism.
      </span>
    ),
  },
  {
    id: 'node-sales',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Node Sales:&nbsp;</span>
        Occasionally, nodes are sold to players, generating additional income.
      </span>
    ),
  },
  {
    id: 'treasury-allocation',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Treasury Allocation:&nbsp;</span>
        Funds are used to enhance game development, marketing, and long-term growth initiatives.
      </span>
    ),
  },
];

export const investors = [
  {
    key: 'maven',
    image: '/launchpad/stories/gpt-wars/maven.png',
    width: 129,
    height: 64,
    className: 'py-[4px] px-[11px]',
  },
  {
    key: 'blokhash',
    image: '/launchpad/stories/gpt-wars/blokhash.png',
    width: 150,
    height: 150,
    className: 'text-center',
  },
  {
    key: 'zbs-capital',
    image: '/launchpad/stories/gpt-wars/zbs-capital.png',
    width: 132,
    height: 77,
    className: 'bg-[#E4E4E4] rounded-lg overflow-hidden',
  },
  {
    key: 'oriole',
    image: '/launchpad/stories/gpt-wars/oriole-ventures.png',
    width: 94,
    height: 94,
    className: 'text-center bg-[#FFCA00]',
  },
];

export const partners = [
  {
    key: 'ape-arcade',
    image: '/launchpad/stories/gpt-wars/ape-arcade.png',
    width: 66,
    height: 71,
  },
  {
    key: 'shadow-war',
    image: '/launchpad/stories/gpt-wars/shadow-war.png',
    width: 154,
    height: 72,
    className: 'rounded-lg overflow-hidden',
  },
  {
    key: 'super-verse',
    image: '/launchpad/stories/gpt-wars/super-verse.png',
    width: 154,
    height: 72,
    className: 'rounded-lg overflow-hidden',
  },
  {
    key: 'exverse',
    image: '/launchpad/stories/gpt-wars/exverse.png',
    width: 128,
    height: 29,
    className: 'bg-[#000] py-[21px] px-[11px]',
  },
  {
    key: 'arcade',
    image: '/launchpad/stories/gpt-wars/arcade.png',
    width: 66,
    height: 66,
    className: 'bg-[#000] text-center',
  },
];

export const tokenUtility = [
  {
    id: 'deflationary-model',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Deflationary Model:&nbsp;</span>
        Revenue from in-game purchases is used for token buybacks and burns, ensuring a stable and
        scarce token supply.
      </span>
    ),
  },
  {
    id: 'ecosystem-currency',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Ecosystem Currency:&nbsp;</span>
        $GPTW is used to purchase skins, loot boxes, upgrades, and participate in in-game economy
        activities.
      </span>
    ),
  },
  {
    id: 'reward-mechanism',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Reward Mechanism:&nbsp;</span>
        Players earn $GPTW through gameplay, incentivizing long-term engagement.
      </span>
    ),
  },
  {
    id: 'self-sustaining-economy',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Self-Sustaining Economy:&nbsp;</span>
        The deflationary mechanism incentivizes token speculation and enhances its intrinsic value.
      </span>
    ),
  },
  {
    id: 'governance',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Governance:&nbsp;</span>
        Token holders have the opportunity to participate in ecosystem governance decisions.
      </span>
    ),
  },
];

export const roadmap = [
  {
    id: 'q3-2024',
    item: (
      <span className="font-normal">
        <p className="font-semibold pb-4">Q3 2024&nbsp;</p>
        <ul className="list-disc pl-6 pb-4">
          <li>Launch of playable beta.</li>
          <li>Release of official trailer.</li>
        </ul>
      </span>
    ),
  },
  {
    id: 'q4-2024',
    item: (
      <span className="font-normal">
        <p className="font-semibold pb-4">Q4 2024&nbsp;</p>
        <ul className="list-disc pl-6 pb-4">
          <li>V1 game launch.</li>
          <li>Free NFT drop for the first 5,000 users.</li>
          <li>Airdrop Season 2.</li>
        </ul>
      </span>
    ),
  },
  {
    id: 'q1-2025',
    item: (
      <span className="font-normal">
        <p className="font-semibold pb-4">Q1 2025&nbsp;</p>
        <ul className="list-disc pl-6 pb-4">
          <li>Introduction of “Tournament Mode.”</li>
          <li>Skins partnerships with 50+ brands.</li>
          <li>Resistance upgrades available for $GPTW.</li>
        </ul>
      </span>
    ),
  },
  {
    id: 'q2-2025',
    item: (
      <span className="font-normal">
        <p className="font-semibold pb-4">Q2 2025&nbsp;</p>
        <ul className="list-disc pl-6 pb-4">
          <li>Robot battles and customization features.</li>
          <li>Robot upgradeables available for purchase.</li>
          <li>Map customization using $GPTW.</li>
        </ul>
      </span>
    ),
  },
];

export const teamMembers = [
  {
    id: 'tomas-rey',
    fullName: 'Tomas Rey',
    about: (
      <p className="font-normal">
        Founder of Tango Labs with extensive blockchain gaming experience, having led token launches
        and advised NASDAQ-listed companies.
        <br />
      </p>
    ),
    width: 104,
    height: 104,
    position: 'Founder & CEO',
    avatar: '/launchpad/stories/gpt-wars/tomas-rey.png',
  },
  {
    id: 'daniel-lopes',
    fullName: 'Daniel Lopes',
    about: (
      <p className="font-normal">
        Web3 and gaming expert with experience in business development for Paxful, Huobi, and
        Bitget.
        <br />
      </p>
    ),
    width: 104,
    height: 104,
    position: 'CBDO',
    avatar: '/launchpad/stories/gpt-wars/daniel-lopes.png',
  },
  {
    id: 'german-lopez-frezza',
    fullName: 'German Lopez Frezza',
    about: (
      <p className="font-normal">
        Blockchain developer with expertise in DeFi and years at Accenture and IBM.
        <br />
      </p>
    ),
    width: 104,
    height: 104,
    position: 'CTO',
    avatar: '/launchpad/stories/gpt-wars/german-lopes-frezza.png',
  },
  {
    id: 'angel-tremosa',
    fullName: 'Angel Tremosa',
    about: (
      <p className="font-normal">
        Over a decade of experience in creative industries, including game design and production.
        <br />
      </p>
    ),
    width: 104,
    height: 104,
    position: 'CPO',
    avatar: '/launchpad/stories/gpt-wars/angel-tremosa.png',
  },
  {
    id: 'martin-contino',
    fullName: 'Martin Contino',
    about: (
      <p className="font-normal">
        Web3 marketing strategist and former professional FPS gamer.
        <br />
      </p>
    ),
    width: 104,
    height: 104,
    position: 'COO',
    avatar: '/launchpad/stories/gpt-wars/martin-contino.png',
  },
];

export const gallery = [
  {
    image: '/launchpad/stories/gpt-wars/app-1.jpeg',
  },
  {
    image: '/launchpad/stories/gpt-wars/app-2.jpeg',
  },
  {
    image: '/launchpad/stories/gpt-wars/app-3.jpeg',
  },
];
